export const SET_NUMBER = "SET_NUMBER";

export const setInvoiceNumber = (data) => ({
  type: SET_NUMBER,
  payload: data,
});
